import { provideHttpClient, withInterceptors} from "@angular/common/http";
import { APP_INITIALIZER, EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from "@angular/core";
import {authDavesaApiInterceptor} from "./auth-davesa-api.interceptor";
import {AuthDavesaV2ApiService} from "./auth-davesa-v2-api.service";
import { AuthDavesaV2Service } from "./auth-davesa-v2.service";

// export const provideAuthDavesaApi = (): Array<Provider | EnvironmentProviders> => {
//     return [
//         provideHttpClient(withInterceptors([authDavesaApiInterceptor])),
//         provideEnvironmentInitializer(() => inject(AuthDavesaApiV2Service)),
//     ];
export const provideAuthDavesaApi = (): Array<Provider | EnvironmentProviders> => {
    return [
        // Note: HttpClient with interceptors is now provided in app.config.ts
        provideEnvironmentInitializer(() => inject(AuthDavesaV2ApiService)),
        {
            provide: APP_INITIALIZER,
            deps: [AuthDavesaV2Service],
            useFactory: () => (): any => null,
            multi: true,
        }
    ];
    
    // return [
    //     provideHttpClient(withInterceptors([authDavesaApiInterceptor])),
    //     {
    //         provide: HTTP_INTERCEPTORS,
    //         useValue: () => inject(AuthDavesaV2Service),
    //         multi: true,
    //     },
    //     {
    //         provide: HTTP_INTERCEPTORS,
    //         useValue: () => inject(ParticipantsV2Service),
    //         multi: true,
    //     },
    //     {
    //         provide: HTTP_INTERCEPTORS,
    //         useValue: () => inject(StudiesV2Service),
    //         multi: true,
    //     },
    // ];
};
